import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "bg-white rounded-lg shadow-md overflow-hidden" }
const _hoisted_2 = { class: "p-4" }
const _hoisted_3 = { class: "space-y-4" }
const _hoisted_4 = { class: "flex-shrink-0 mr-3" }
const _hoisted_5 = { class: "h-8 w-8 rounded-full bg-blue-100 flex items-center justify-center text-blue-500 font-semibold" }
const _hoisted_6 = {
  key: 0,
  class: "text-sm"
}
const _hoisted_7 = { class: "font-medium" }
const _hoisted_8 = { class: "text-gray-500" }
const _hoisted_9 = {
  key: 1,
  class: "text-sm"
}
const _hoisted_10 = { class: "font-medium" }
const _hoisted_11 = { class: "text-gray-500" }
const _hoisted_12 = { class: "font-medium" }
const _hoisted_13 = { class: "text-xs text-gray-500 mt-1" }
const _hoisted_14 = {
  key: 1,
  class: "text-center py-6"
}

import { TaskDocProfile } from '@/features/task-management';

// Props

export default /*@__PURE__*/_defineComponent({
  __name: 'ActivityFeed',
  props: {
  activities: {
    type: Array as () => TaskDocProfile[],
    required: true
  }
},
  setup(__props) {



// Get initials from name
const getInitials = (name: string): string => {
  if (!name) return '';
  
  return name
    .split(' ')
    .map(part => part.charAt(0))
    .join('')
    .toUpperCase()
    .substring(0, 1);
};

// Map action name to verb phrase
const getActionVerb = (action: string): string => {
  if (!action) return ' ';
  
  const actionMap: Record<string, string> = {
    'COMMENT': ' commented on ',
    'DOWNLOAD': ' downloaded ',
    'UPLOAD': ' uploaded ',
    'APPROVE_REJECT': ' reviewed ',
    'REVIEW': ' reviewed ',
    'REQUEST': ' requested ',
    'ADJUST': ' adjusted ',
    'REVISE': ' revised ',
    'REMIND': ' reminded '
  };
  
  return actionMap[action] || action.toLowerCase();
};

// Format time ago
const formatTimeAgo = (timestamp: string | null | undefined): string => {
  if (!timestamp) return '';
  
  const date = new Date(timestamp);
  const now = new Date();
  const diffMs = now.getTime() - date.getTime();
  const diffMins = Math.floor(diffMs / 60000);
  const diffHours = Math.floor(diffMins / 60);
  const diffDays = Math.floor(diffHours / 24);
  
  if (diffMins < 1) {
    return 'just now';
  } else if (diffMins < 60) {
    return `${diffMins} minute${diffMins !== 1 ? 's' : ''} ago`;
  } else if (diffHours < 24) {
    return `${diffHours} hour${diffHours !== 1 ? 's' : ''} ago`;
  } else {
    return `${diffDays} day${diffDays !== 1 ? 's' : ''} ago`;
  }
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[2] || (_cache[2] = _createElementVNode("div", { class: "p-4 border-b border-gray-200 flex justify-between items-center" }, [
      _createElementVNode("div", null, [
        _createElementVNode("h2", { class: "text-xl font-semibold" }, "Activity Feed"),
        _createElementVNode("p", { class: "text-sm text-gray-500" }, "Recent actions by team members")
      ])
    ], -1)),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("ul", _hoisted_3, [
        (__props.activities.length > 0)
          ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(__props.activities, (activity) => {
              return (_openBlock(), _createElementBlock("li", {
                key: activity.id,
                class: "flex items-start"
              }, [
                _createElementVNode("div", _hoisted_4, [
                  _createElementVNode("div", _hoisted_5, _toDisplayString(getInitials(activity.user_name)), 1)
                ]),
                _createElementVNode("div", null, [
                  (activity.description)
                    ? (_openBlock(), _createElementBlock("p", _hoisted_6, [
                        _createElementVNode("span", _hoisted_7, _toDisplayString(activity.user_name), 1),
                        _createElementVNode("span", _hoisted_8, ": " + _toDisplayString(activity.description), 1)
                      ]))
                    : (_openBlock(), _createElementBlock("p", _hoisted_9, [
                        _createElementVNode("span", _hoisted_10, _toDisplayString(activity.user_name), 1),
                        _createElementVNode("span", _hoisted_11, _toDisplayString(getActionVerb(activity.action)), 1),
                        _createElementVNode("span", _hoisted_12, _toDisplayString(activity.document_name), 1)
                      ])),
                  _createElementVNode("p", _hoisted_13, [
                    _cache[0] || (_cache[0] = _createElementVNode("svg", {
                      class: "inline-block h-3 w-3 mr-1",
                      fill: "none",
                      stroke: "currentColor",
                      viewBox: "0 0 24 24",
                      xmlns: "http://www.w3.org/2000/svg"
                    }, [
                      _createElementVNode("path", {
                        "stroke-linecap": "round",
                        "stroke-linejoin": "round",
                        "stroke-width": "2",
                        d: "M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"
                      })
                    ], -1)),
                    _createTextVNode(" " + _toDisplayString(formatTimeAgo(activity.done_at)), 1)
                  ])
                ])
              ]))
            }), 128))
          : _createCommentVNode("", true),
        (__props.activities.length === 0)
          ? (_openBlock(), _createElementBlock("li", _hoisted_14, _cache[1] || (_cache[1] = [
              _createElementVNode("p", { class: "text-gray-500" }, "No recent activities", -1)
            ])))
          : _createCommentVNode("", true)
      ])
    ])
  ]))
}
}

})